// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"258":"edd22330","703":"3018dfc9","787":"c9aba920"}[chunkId] + ".chunk.js";
};